
import { Component, Vue, Prop } from "vue-property-decorator";
import Xinlv from "./components/xinlv/xinlv.vue";
import Xindian from "./components/xindian/xindian.vue";
import Xueyang from "./components/xueyang/xueyang.vue";
import Xueya from "./components/xueya/xueya.vue";
import Tiwen from "./components/tiwen/tiwen.vue";
import Maibo from "./components/maibo/maibo.vue";
import Xuetang from "./components/xuetang/xuetang.vue";
import Xinzangwuyou from "./components/xinzangwuyou/xinzangwuyou.vue";
import Tizhi from "./components/tizhi/tizhi.vue";
@Component({
  components: {
    Xinlv,
    Xindian,
    Xueyang,
    Xueya,
    Tiwen,
    Maibo,
    Xuetang,
    Xinzangwuyou,
    Tizhi,
  },
})
export default class Name extends Vue {
  private leftTree: any = [
    {
      label: "健康指标",
      isOpen: true,
      children: [
        {
          parent: "健康指标",
          label: "心率",
        },
        {
          parent: "健康指标",
          label: "心电",
        },
        {
          parent: "健康指标",
          label: "血氧饱和度",
        },
        {
          parent: "健康指标",
          label: "血压",
        },
        {
          parent: "健康指标",
          label: "体温",
        },
        {
          parent: "健康指标",
          label: "脉搏",
        },
        {
          parent: "健康指标",
          label: "血糖",
        },
      ],
    },
    {
      label: "健康评估",
      isOpen: true,
      children: [
        {
          parent: "健康评估",
          label: "心脏无忧筛查",
        },
        // {
        //   parent: "健康评估",
        //   label: "中医体质辨识",
        // },
      ],
    },
  ];
  private currentTree: any = {
    parent: "健康指标",
    label: "心率",
  };
  private refreshEcharts() {
    if (this.currentTree.label === "心率") {
      (this.$refs.xinlv as any).refreshEcharts();
    } else if (this.currentTree.label === "血氧饱和度") {
      (this.$refs.xueyang as any).refreshEcharts();
    } else if (this.currentTree.label === "血压") {
      (this.$refs.xueya as any).refreshEcharts();
    } else if (this.currentTree.label === "体温") {
      (this.$refs.tiwen as any).refreshEcharts();
    } else if (this.currentTree.label === "脉搏") {
      (this.$refs.maibo as any).refreshEcharts();
    } else if (this.currentTree.label === "血糖") {
      (this.$refs.xuetang as any).refreshEcharts();
    } else if (this.currentTree.label === "心脏无忧筛查") {
      (this.$refs.xinzangwuyou as any).refreshEcharts();
    }
  }
  private refresh() {}
  private changePart(item: any) {
    this.currentTree = item;
  }
  mounted() {}
}
